export function GoldBar() {
  return (
    <div
      style={{
        background:
          "linear-gradient(318.76deg, #E9BE12 4.97%, #F5D114 39.44%, #D0990D 102.31%)",
        height: 12,
      }}
    />
  );
}
